import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, message, Select } from 'antd';
import { oneKlicks } from '../../SDK/oneclick';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import ImageShow from '../../Uitiles/ImageShow';
import decodeHtml from '../../Uitiles/decodeHtml';
import { debugLog } from '../../utils/debug';

const SpecialityName = ({ id }) => {
    const [speciality_details, setSpecialityDetails] = useState(null);

    useEffect(() => {
        if (id) {
            getSpecialityDetails();
        }
    }, [id]);

    const getSpecialityDetails = async () => {
        try {
            const tableSchema = '';
            const tableName = 'specialities';
            const conditions = { id: id };
            const response = await oneKlicks.read(tableSchema, tableName, conditions, '', '', '', '');

            if (response && response.data && response.data.length > 0) {
                setSpecialityDetails(response.data[0]);
            } else {
                setSpecialityDetails(null);
            }
        } catch (error) {
            console.error('Error fetching speciality details:', error);
        }
    };

    return (
        <p className="text-capitalize" style={{ fontWeight: 500, color: '#2b3674' }}>
            {speciality_details ? decodeHtml(speciality_details.name) : <span style={{ color: '#a3aed1', fontStyle: 'italic' }}>Unmapped</span>}
        </p>
    );
};

export default SpecialityName;





